import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-prevet-travel-fields',
  templateUrl: './prevet-travel.component.html',
  styleUrls: []
})

export class PreVetTravelFormComponent {
  @Input() noteFields: any[];
  @Input() newNote: any;
  @Input() noteForm?: any;

  public normalOrAbnormalFields = [
    'hk_cardiac_auscultation',
    'hk_clinical_examination',
    'hk_examination_left_fore',
    'hk_examination_right_fore',
    'hk_examination_left_hind',
    'hk_examination_right_hind'
  ]

  getToggleInputName(field: any): string {
    var name = `comments[${field.id}_text]`;
    return name;
  }

  updateCheckboxFieldValue(_newNote: any, field: any) {
    if (this.newNote[field.name] && this.newNote[field.name] === 'true') {
      this.newNote[field.name] = ''; //for false
    } else {
      this.newNote[field.name] = 'true'
    }

    if (!this.newNote[field.name] && this.newNote.id <= 0) {
      delete this.newNote[`comments[${field.id}_text]`];
    }
  }

  isAbnormalOrNormalTypes(type: string) {
    if (this.normalOrAbnormalFields.includes(type)) {
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/component/prevet_travel.component.ts